<mdb-error style="position: relative; display: block; top: 0 !important;">{{ text() | translate }}</mdb-error>
